export default __webpack_public_path__ + "static/media/gltf.e7a7909d.svg";